export default __webpack_public_path__ + "static/media/nomineeSuccessIcon.27a10005.svg";